import Vue from 'vue'
import VeeValidate, {Validator} from "vee-validate";
import zh_CN from 'vee-validate/dist/locale/zh_CN'

const config = {
  locale: 'zh_CN',
  fieldsBagName: 'fieldsBag'
};
Vue.use(VeeValidate, config);
Validator.localize(zh_CN);

Validator.extend('phone', {
  messages: {
    zh_CN: field => field + '必须是11位手机号码',
  },
  validate: value => {
    return value.length === 11 && /^(1\d{10})$/.test(value)
  }
})
const dictionary = {
  zh_CN: {
    messages: {
      required: function (field) {
        if (field === "password") {
          field = "密码"
        }
        if (field === "code") {
          field = "验证码"
        }
        if (field === "email") {
          field = "邮箱"
        }
        return "请输入" + field
      },
      max: "字符超过限制的长度",
      email: "邮箱不合法",
      phone: "输入的手机号不正确",
      digits: () => '请输入6位数字',
    },
    attributes: {
      mobile: "手机号码",
      linkMan: "姓名",
      userName: "用户名",
      email: '邮箱',
      code:'验证码'
    }
  }
}

Validator.localize(dictionary);
